// extracted by mini-css-extract-plugin
export default {"container":"container___Zd2Y5","form":"form___UWJgG"};